<template>
  <div class="content">
    <!--
    <h1 class="has-text-centered is-hidden-mobile">Willkommen auf Elektrotechnik-Rechner.at!</h1>
    <h1 class="has-text-centered is-hidden-tablet mt-0">Willkommen!</h1>
    -->
    <div class="box">
      <h1 class="has-text-centered is-hidden-mobile">Willkommen auf Elektrotechnik-Rechner.at!</h1>
      <h1 class="has-text-centered is-hidden-tablet mt-0">Willkommen!</h1>
      <p>
        Hier findest du <router-link :to="{name: 'formulas'}">Formeln</router-link>, <router-link :to="{name: 'calculators'}">Rechner</router-link>, <router-link :to="{name: 'tables'}">Tabellen</router-link> und andere hilfreiche Tools aus bzw. für den Bereich der Elektrotechnik.<br>
        Zusätzlich gibt es auch eine wachsende Anzahl von kompakten Zusammenfassungen zu <router-link :to="{name: 'electrical-elements'}">elektrischen Bauelementen</router-link> und <router-link :to="{name: 'network-engineering'}">Themen aus der Netzwerktechnik</router-link>.
      </p>
      <p>
        Wenn du Elektrotechnik lernen möchtest, wirf einen Blick auf <router-link :to="{name: 'learning'}">diese Lesezeichen</router-link>. Dort findest du einige nützliche URLs die dir dabei weiterhelfen können.
      </p>
      <p>
        Feedback, Wünsche und Verbesserungsvorschläge sind jederzeit willkommen. Einfach eine E-Mail an
        <a href="mailto:kontakt@elektrotechnik-rechner.at">kontakt@elektrotechnik-rechner.at</a>
        schicken.
      </p>
    </div>
    <div class="columns">
      <div class="column is-one-third">
        <router-link :to="{name: 'calculators'}">
          <div class="box is-wordWrapBreakWord is-fullHeight is-clickable has-text-centered is-hoverable-box">
            <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" fill="currentColor" class="bi bi-calculator-fill" viewBox="0 0 16 16">
              <path
                d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm2 .5v2a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5zm0 4v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5zM4.5 9a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1zM4 12.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5zM7.5 6a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1zM7 9.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5zm.5 2.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1zM10 6.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5zm.5 2.5a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5h-1z"
              />
            </svg>
            <h2 class="mt-4">Rechner</h2>
          </div>
        </router-link>
      </div>
      <div class="column is-one-third">
        <router-link :to="{name: 'formulas'}">
          <div class="box is-wordWrapBreakWord is-fullHeight is-clickable has-text-centered is-hoverable-box">
            <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" fill="currentColor" class="bi bi-book" viewBox="0 0 16 16">
              <path
                d="M1 2.828c.885-.37 2.154-.769 3.388-.893 1.33-.134 2.458.063 3.112.752v9.746c-.935-.53-2.12-.603-3.213-.493-1.18.12-2.37.461-3.287.811V2.828zm7.5-.141c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.923c-.918-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492V2.687zM8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 0 0 0 2.5v11a.5.5 0 0 0 .707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 0 0 .78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0 0 16 13.5v-11a.5.5 0 0 0-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783z"
              />
            </svg>
            <h2 class="mt-4">Formelsammlung</h2>
          </div>
        </router-link>
      </div>
      <div class="column is-one-third">
        <router-link :to="{name: 'tables'}">
          <div class="box is-wordWrapBreakWord is-fullHeight is-clickable has-text-centered is-hoverable-box">
            <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" fill="currentColor" class="bi bi-file-earmark-spreadsheet" viewBox="0 0 16 16">
              <path
                d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V9H3V2a1 1 0 0 1 1-1h5.5v2zM3 12v-2h2v2H3zm0 1h2v2H4a1 1 0 0 1-1-1v-1zm3 2v-2h3v2H6zm4 0v-2h3v1a1 1 0 0 1-1 1h-2zm3-3h-3v-2h3v2zm-7 0v-2h3v2H6z"
              />
            </svg>
            <h2 class="mt-4">Tabellen</h2>
          </div>
        </router-link>
      </div>
    </div>
    <div class="columns is-centered">
      <div class="column is-one-third">
        <router-link :to="{name: 'pins'}">
          <div class="box is-wordWrapBreakWord is-fullHeight is-clickable has-text-centered is-hoverable-box">
            <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" fill="currentColor" class="bi bi-cpu" viewBox="0 0 16 16">
              <path
                d="M5 0a.5.5 0 0 1 .5.5V2h1V.5a.5.5 0 0 1 1 0V2h1V.5a.5.5 0 0 1 1 0V2h1V.5a.5.5 0 0 1 1 0V2A2.5 2.5 0 0 1 14 4.5h1.5a.5.5 0 0 1 0 1H14v1h1.5a.5.5 0 0 1 0 1H14v1h1.5a.5.5 0 0 1 0 1H14v1h1.5a.5.5 0 0 1 0 1H14a2.5 2.5 0 0 1-2.5 2.5v1.5a.5.5 0 0 1-1 0V14h-1v1.5a.5.5 0 0 1-1 0V14h-1v1.5a.5.5 0 0 1-1 0V14h-1v1.5a.5.5 0 0 1-1 0V14A2.5 2.5 0 0 1 2 11.5H.5a.5.5 0 0 1 0-1H2v-1H.5a.5.5 0 0 1 0-1H2v-1H.5a.5.5 0 0 1 0-1H2v-1H.5a.5.5 0 0 1 0-1H2A2.5 2.5 0 0 1 4.5 2V.5A.5.5 0 0 1 5 0zm-.5 3A1.5 1.5 0 0 0 3 4.5v7A1.5 1.5 0 0 0 4.5 13h7a1.5 1.5 0 0 0 1.5-1.5v-7A1.5 1.5 0 0 0 11.5 3h-7zM5 6.5A1.5 1.5 0 0 1 6.5 5h3A1.5 1.5 0 0 1 11 6.5v3A1.5 1.5 0 0 1 9.5 11h-3A1.5 1.5 0 0 1 5 9.5v-3zM6.5 6a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3z"
              />
            </svg>
            <h2 class="mt-4">Pin- und Steckerbelegungen</h2>
          </div>
        </router-link>
      </div>
      <div class="column is-one-third">
        <router-link :to="{name: 'glossary'}">
          <div class="box is-wordWrapBreakWord is-fullHeight is-clickable has-text-centered is-hoverable-box">
            <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" fill="currentColor" class="bi bi-list-ul" viewBox="0 0 16 16">
              <path
                fill-rule="evenodd"
                d="M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm-3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
              />
            </svg>
            <h2 class="mt-4">Glossar</h2>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ee-start',
  metaInfo: {
    title: 'Online App für Techniker',
    meta: [
      {
        name: 'description',
        content: 'Rechner, Tabellen, Formeln und mehr aus dem Bereich der Elektrotechnik.'
      }
    ]
  },
  created () {
    this.$store.commit('updateNavTitle', { title: 'Elektrotechnik-Rechner.at', route: 'start' })
  }
}
</script>
